import { Directive, ElementRef, Input, output, Output } from '@angular/core';

@Directive({
  selector: '[hp][authCode]',
  host: {
    '(input)': 'onInputChange($event)',
    '(keydown)': 'onKeyDown($event)',
  },
  standalone: true,
})
export class AuthCodeDirective {
  el: HTMLInputElement;
  private previousValue: string = '';

  realnum = output<number>();

  @Input() set initial(value: number) {
    this.updateValue(value);
  }

  constructor(private elementRef: ElementRef) {
    this.el = this.elementRef.nativeElement;
  }

  ngOnInit() { }

  private updateValue(value: number) {
    const numericValue = value / 100;
    const formattedValue = this.formatWithSpaces(numericValue.toString());
    this.el.value = formattedValue;
    this.previousValue = numericValue.toString();
  }

  onInputChange(event: Event) {
    const inputValue = this.el.value.replace(/[^0-9]/g, '');
    if (inputValue !== this.previousValue) {
      const numericValue = Number(inputValue);
      const formattedValue = this.formatWithSpaces(inputValue);
      this.el.value = formattedValue;
      this.previousValue = inputValue;
      this.realnum.emit(numericValue);
    }
  }

  onKeyDown(event: KeyboardEvent) {
    const key = event.key;
    if (key === 'Backspace') {
      event.preventDefault();
      const currentValue = this.el.value.replace(/[^0-9]/g, '');
      const newValue = currentValue.slice(0, -1);
      const formattedValue = this.formatWithSpaces(newValue);
      this.el.value = formattedValue;
      this.previousValue = newValue;
      this.realnum.emit(Number(newValue));
    }
  }

  private formatWithSpaces(value: string): string {
    let formatted = value;
    if (value.length > 2) {
      formatted = value.slice(0, 2) + ' ' + value.slice(2);
    }
    if (value.length > 6) {
      formatted = formatted.slice(0, 6) + ' ' + formatted.slice(6);
    }
    return formatted;
  }
}
